/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  /* Fix input doesn't focus in Brooklyn theme */
  InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function(isClose) {
    jQ('.mfp-close').trigger('click');
  }

  InstantSearchResult.prototype.setData = function($instantSearchResult, data, isLoading) {
    this.$instantSearchResult = $instantSearchResult;
    this.data = data;
    this.isLoading = isLoading;

    if (this.data) {
        // Add redirect data to suggestion term
        this.setRedirectData();

        // Set data for Suggestion blocks
        var noProducts = this.data.filter(function(e) {
          return e.key == 'products' && e.values.length == 0;
        })
        var isAllEmpty = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.ALL_EMPTY, this.data) && !this.hasRedirectData;
        if (typeof noProducts[0] !== 'undefined') {
          isAllEmpty = true;
        } else {
          isAllEmpty = false;
        }
        var suggestQuery = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.SUGGEST_QUERY, this.data);
        var dym = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.DID_YOU_MEAN, this.data);

        // Set data for blocks
        this.blocks.forEach((block) => {
            var blockData = Utils.getValueInObjectArray(block.type, this.data);
            // Set the popular data for products block and sugestion block if return not found result
            if (isAllEmpty && !suggestQuery && (!dym || dym.length == 0)) {
                var noResultData = InstantSearchNoResult.getNoResultData();
                var noResultBlock = noResultData[block.type];
                if (noResultBlock) {
                    blockData = noResultBlock;
                }
            }

            // Set data for block
            block.setData(blockData, isAllEmpty);
        });

        // Set data for empty block
        this.blockEmpty.setData(this.data);

        // Set data for view all block
        this.blockViewAll.setData(this.data);
    }
}
})();